import React from 'react';

import { AppNav } from 'core/containers';
import { ScrollToTop, EnvironmentBar } from 'shared';

interface Props {
  children: JSX.Element;
}

export const DefaultLayout: React.FunctionComponent<Props> = (props: Props): JSX.Element => {
  return (
    <>
      <EnvironmentBar />
      <div className="appContent flex flex-column align-items-center" style={{ paddingTop: 56 }}>
        <ScrollToTop>
          <>
            <AppNav />
            {props.children}
          </>
        </ScrollToTop>
      </div>
    </>
  );
};
